export type TimeResolution = 'Hours' | 'Days' | 'Weeks' | 'Months'
export function isTimeResolution(test: string | null): test is TimeResolution {
  if (test === null) return false
  return ['Hours', 'Days', 'Weeks', 'Months'].includes(test)
}
